import type { AiChat } from '../common/ai-chat/aiChatTypes';
import type { AgentType } from '@server/ai';
import type { ChatInstance } from './ChatInstance';
import type { AgentState } from './agentsChatsTypes';

export const AGENTS_CHATS_SLICE_NAME = 'agentsChats';

export const GHOST_CHAT_ID = 'GHOST_CHAT_ID'; // represents an empty chat - user hasn't sent any prompt

export const TEMP_CHAT_ID = 'TEMP_CHAT_ID'; // represents a new chat, from the moment the user sends the first message until getting the reply from the BE with the chat id

export const isTempChatId = (chatId: string) => chatId === TEMP_CHAT_ID;

export const getAgentInitialState = (chatInstanceId?: ChatInstance): AgentState => ({
  chatsList: {
    isLoadingChatList: false,
  },
  chatsDetails: {},
  ...(chatInstanceId
    ? {
        activeChatIds: {
          [chatInstanceId]: GHOST_CHAT_ID,
        } as { [K in ChatInstance]?: string },
      }
    : { activeChatIds: {} as { [K in ChatInstance]?: string } }),
});

export const getChatInitialState = ({
  agentId,
  agentType,
  id,
}: {
  agentId: string;
  agentType: AgentType;
  id: string;
}): AiChat => ({
  id,
  name: 'New chat',
  aiChatDetails: { messages: [] },
  isFavorite: false,
  updatedAt: new Date().toISOString(),
  isLoadingResponse: false,
  agentId,
  agentType,
  hasStream: false,
  userId: '',
});
